import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductSettingMcItem, ProductSettingMcsInput } from '@app/services/product-setting.service';

@Component({
    selector: 'tt-product-setting-mcs-form',
    templateUrl: './product-setting-mcs-form.component.html',
    styleUrls: ['./product-setting-mcs-form.component.css'],
})
export class ProductSettingMcsFormComponent {
    @Input()
    public data: ProductSettingMcsInput[] = [];

    @Output()
    public dataChange = new EventEmitter<ProductSettingMcsInput[]>();

    /**
     * Any items that belong to a select list in the input list.
     */
    @Input()
    public items: { [key: string]: ProductSettingMcItem[] } = {};

    @Input()
    public hideCounterAfterAssign = false;

    @Output()
    public blur = new EventEmitter<void>();

    public trackBy = (_: number, item: ProductSettingMcsInput) => {
        return item.productsettingmc_keyno;
    };
}
